import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import CardTemplate from "../Common/CardTemplate";
import {

    Typography,

    Button,
    Box,

    Stack,

} from "@mui/material";
import { AppContext } from "../../AppContext";

import dayjs from "dayjs";
import "dayjs/locale/fr";
//import { TimeZoneFilterSensitiveLog } from "@aws-sdk/client-location";
var utc = require('dayjs/plugin/utc')
var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);
dayjs.locale("fr");
dayjs.extend(utc);

export default function ProspectsCard({ actualDeal }) {
    const app = useContext(AppContext);
    return (
        <CardTemplate
            title="Acquéreurs"

            content={
                <Fragment>

                    {actualDeal.prospects &&
                        actualDeal.prospects.map((row) => (
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box >
                                    <Typography variant="body1">{row.name}</Typography>
                                </Box>
                                <Box >
                                    {row.pf !== null && (<Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent={"space-between"}
                                    >
                                        <Box>
                                            <Stack>
                                                <Typography variant="h5">Offre à {row.pf.p} €</Typography>
                                                {row.pf !== null && (<Typography variant="body1">L'offre expire {dayjs(row.pf.d).utc().utcOffset(120).fromNow()}</Typography>)}
                                            </Stack>
                                        </Box>
                                    </Box>)}
                                    {row.pf === null && (
                                        <Box p={1}><Typography variant="body1"><em>Pas d'offre</em></Typography></Box>
                                    )}
                                </Box>
                                {(actualDeal.idp && row.pf !== null) && (
                                    <Box >
                                        <Button
                                            variant="contained"
                                            onClick={
                                                () => app.refPopUp.current.handleChangeState(
                                                    {
                                                        opened: true,
                                                        type: "013",
                                                        params: {
                                                            pf: row.pf,
                                                            app: app
                                                        }
                                                    }
                                                )}
                                        >
                                            VOIR
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        ))}

                    {actualDeal.pub && actualDeal.prospects.length == 0 && (
                        <div style="padding: 10px;">
                            <Typography variant="body1"><em>Pas d'acquéreur</em></Typography>
                        </div>
                    )}
                </Fragment>
            }
        />)

}